export const enum Environment {
    Development, Testing, Accept, Production
}

function getEnv(str: string): Environment {
    switch (str) {
        case 'development':
            return Environment.Development;
        case 'testing':
            return Environment.Testing;
        case 'accept':
            return Environment.Accept;
        case 'production':
        default:
            return Environment.Production;
    }
}

export function getEnvString(env: Environment): string {
    switch (env) {
        case Environment.Development:
            return 'development';
        case Environment.Testing:
            return 'testing';
        case Environment.Accept:
            return 'accept';
        case Environment.Production:
            return 'production';
        default:
            throw new Error(`Environment ${env} does not exist!`);
    }
}

export function getShortEnv(env: Environment): string {
    switch (env) {
        case Environment.Development:
            return 'dev';
        case Environment.Testing:
            return 'test';
        case Environment.Accept:
            return 'accept';
        default:
            return '';
    }
}

export function shortEnvToEnum(shortStr: string): Environment {
    switch (shortStr) {
        case 'dev':
            return Environment.Development;
        case 'test':
            return Environment.Testing;
        case 'accept':
            return Environment.Accept;
        default:
            return Environment.Production;
    }
}

let environment = getEnv(process.env.NODE_ENV || '');

if (typeof process !== 'undefined' && typeof process.argv !== 'undefined') {
    if (process.argv.indexOf('dev') >= 0) {
        environment = Environment.Development;
    } else if (process.argv.indexOf('test') >= 0) {
        environment = Environment.Testing;
    } else if (process.argv.indexOf('accept') >= 0) {
        environment = Environment.Accept;
    }
}

export const shortEnv = getShortEnv(environment);
export default environment;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/environment.ts